import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import './mathsubject.css';
import '../App.css';

const TeacherPage = () => {
    const {auth} = useAuth();

    if (auth?.userRole1 !== "teacher") {
        return(
            <div className="problem">
                <p>티프매쓰에 선생님으로 등록하신 분들만 사용할 수 있습니다. 티프매쓰 선생님으로 등록 신청을 하세요.</p>
            </div>
        )
    }
    return(
        <div className="subjectbox-1">
            <div className="subjectsidebar-4" style={{fontWeight:"bolder", color:"orange" ,marginTop:"10px", marginBottom:"1px", marginLeft:"30px"}}>
                <Link to={`/teacher/student/searchstudent`}>
                    <h5>학생 찾기</h5>
                </Link>
                <Link to={`/teacher/student/viewregisteredstudentlist`}>
                    <h5>학생 관리</h5>
                </Link>
            </div>
        </div>
    )
}

export default TeacherPage;